import React, { Component } from "react";
import "./PlanSuggestionQuestionSingleSlider.css";

import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import MediaQuery from "react-responsive";

class PlanSuggestionQuestionSingleSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
    };

    this.onQuestionNext = this.props.onQuestionNext.bind(this);
    this.onQuestionBack = this.props.onQuestionBack.bind(this);
  }

  getTrackingIdByValue(value) {
    const { options } = this.props.data;
    const option = options[value];

    if (option == null) return null;

    return option.trackingId;
  }

  render() {
    const { data } = this.props;
    const {
      headerTc,
      headerEn,
      questionTc,
      questionEn,
      options,
      trackingIdBack,
      trackingIdNext,
    } = data;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const header = lang === "tc" ? headerTc : headerEn;
    const question = lang === "tc" ? questionTc : questionEn;
    const labelBack = lang === "tc" ? "上一步" : "Back";
    const labelNext = lang === "tc" ? "下一步" : "Next";
    const defaultLargeDeviceMarkStyle = {
      color: "#FFFFFF",
      fontSize: "15px",
      marginTop: "10px",
      width: "max-content",
    };

    const defaultSmallDeviceMarkStyle = {
      color: "#FFFFFF",
      fontSize: "12px",
      marginTop: "10px",
      width: "max-content",
      maxWidth: "80px",
    };

    const marksSmallDevice = options.map((i) => ({
      label: lang === "tc" ? i.labelTc : i.labelEn,
      style: defaultSmallDeviceMarkStyle,
    }));

    const marksLargeDevice = options.map((i) => ({
      label: lang === "tc" ? i.labelTc : i.labelEn,
      style: defaultLargeDeviceMarkStyle,
    }));

    return (
      <div className="card-question-single-slider">
        <div className="header">{header}</div>

        <div className="body">
          <div className="question">{question}</div>

          <div className="container-options">
            <MediaQuery maxWidth={767.98}>
              <Slider
                min={0}
                max={options.length - 1}
                defaultValue={0}
                marks={marksSmallDevice}
                railStyle={{
                  height: "12px",
                  borderRadius: "2rem",
                }}
                handleStyle={{
                  height: "20px",
                  width: "20px",
                  boxShadow: "0px 0px 5px 0px #00000080",
                  borderColor: "#FFFFFF",
                }}
                trackStyle={{
                  height: "12px",
                  width: "12px",
                  border: 0,
                  backgroundColor: "#7356D9",
                }}
                dotStyle={{
                  display: "none",
                }}
                onChange={(value) => {
                  this.setState({ value });
                }}
                onAfterChange={(value)=>{
                  window.trackCustomLink(
                    `Online Acq. Select Plan Section | ${this.getTrackingIdByValue(
                      value
                    )}`
                  );
                }}
                step={null}
              />
            </MediaQuery>

            <MediaQuery minWidth={768}>
              <Slider
                min={0}
                max={options.length - 1}
                defaultValue={0}
                marks={marksLargeDevice}
                railStyle={{
                  height: "16px",
                  borderRadius: "2rem",
                }}
                handleStyle={{
                  height: "24px",
                  width: "24px",
                  boxShadow: "0px 0px 5px 0px #00000080",
                  borderColor: "#FFFFFF",
                }}
                trackStyle={{
                  height: "16px",
                  width: "16px",
                  border: 0,
                  backgroundColor: "#7356D9",
                }}
                dotStyle={{
                  display: "none",
                }}
                onChange={(value) => {
                  this.setState({ value });
                }}
                onAfterChange={(value)=>{
                  window.trackCustomLink(
                    `Online Acq. Select Plan Section | ${this.getTrackingIdByValue(
                      value
                    )}`
                  );
                }}
                step={null}
              />
            </MediaQuery>
          </div>

          <div class="container-button-group">
            <button
              className="btn-outline-transparent"
              onClick={() => {
                window.trackCustomLink(
                  `Online Acq. Select Plan Section | ${trackingIdBack}`
                );
                this.onQuestionBack();
              }}
            >
              {labelBack}
            </button>

            <button
              className="btn-outline-transparent"
              onClick={() => {
                window.trackCustomLink(
                  `Online Acq. Select Plan Section | ${trackingIdNext}`
                );
                this.onQuestionNext(this.state.value);
              }}
            >
              {labelNext}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default PlanSuggestionQuestionSingleSlider;
